import React from 'react';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css'; // you already have this
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";


// const container = document.getElementById("root");
const root = createRoot(document.getElementById("root"));
//root.render(<CareerPage />);

//const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
